import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ADMIN_API } from "../../common/common";
import { Logout } from "../../common/Funcation";
import Loader from "../../components/Loader";
import { postApi, notifyError } from "../../service";
import moment from "moment";

function SABADownline() {
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d;
  });
  const [endDate, setEndDate] = useState(new Date());
  const [dataSource, setDataSource] = useState("DB");
  const [isLoader, setLoader] = useState(false);

  const navigate = useNavigate();
  const [pageData, setPageData] = useState<any>({});

  useEffect(() => {
    getPageData();
    return () => {};
  }, []);

  const getPageData = async (
    ID: string = "",
    FROM: string = "",
    TO: string = "",
    FILTER: string = "",
  ) => {
    //TYPE: string, PAGE: string, SEARCH: string = ''
    let data: any = {
      api: ADMIN_API.REPORT.DOWN_LINE_CASINO,
      value: {
        // type: TYPE,
        // page: PAGE ? PAGE : '1',
        // limit: '10'
      },
    };
    if (ID !== "") {
      data.value.id = ID;
    }
    if (TO !== "") {
      data.value.to = TO;
    }
    if (FROM !== "") {
      data.value.from = FROM;
    }
    if (FILTER !== "") {
      data.value.filter = FILTER;
    }

    setLoader(true);
    await postApi(data)
      .then(function (response) {
        console.log(response);
        setPageData(response.data.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response.data.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };
  const handlePageClick = (e: any) => {
    console.log("page clicked", e);
    getPageData();
  };

  const filterButtonClick = (TYPE: string) => {
    const today = new Date();
    if (TYPE === "today") {
      setStartDate(new Date(today));
      setEndDate(new Date(today));
    } else if (TYPE === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      setStartDate(yesterday);
      setEndDate(new Date(today));
    }
    const fromDate = moment(startDate).format("YYYY-MM-DD");
    const toDate = moment(endDate).format("YYYY-MM-DD");
    const from = `${fromDate}T00:00:00.000Z`;
    const to = `${toDate}T23:59:59.000Z`;
    getPageData("", from, to, TYPE);
  };
  const getFilterButtonClick = () => {
    // Add time to dates for validation
    const startDateTime = moment(startDate).set({
      hour: 0,
      minute: 0,
      second: 0,
    });
    const endDateTime = moment(endDate).set({
      hour: 23,
      minute: 59,
      second: 59,
    });

    // Validate date range
    const daysDiff = moment(endDate).diff(moment(startDate), "days");

    if (daysDiff > 31) {
      notifyError("Date range cannot exceed 31 days");
      return;
    }

    // Validate full datetime (date + time)
    if (startDateTime.isAfter(endDateTime)) {
      notifyError("Start date/time cannot be after end date/time");
      return;
    }

    if (startDateTime.isSame(endDateTime)) {
      notifyError("Start date/time cannot be the same as end date/time");
      return;
    }

    const fromDate = moment(startDate).format("YYYY-MM-DD");
    const toDate = moment(endDate).format("YYYY-MM-DD");
    const from = `${fromDate}T00:00:00.000Z`;
    const to = `${toDate}T23:59:59.000Z`;
    getPageData("", from, to, "all");
  };

  const userClick = (USER: any) => {
    if (USER.agent_level && USER.agent_level !== "PL") {
      getPageData(USER._id, "", "", "all");
    }
  };
  const getAdminClick = () => {
    getPageData("", "", "", "all");
  };

  return (
    <>
      <div className="container main_wrap">
        <div className="top_header">
          <div className="top_header_title">
            <h5>Profit/Loss Report by Downline</h5>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <label className="data-l">Data source :</label>
          <select
            style={{ height: "25px", margin: "0 5px" }}
            name="dataSource"
            id="dataSource"
            value={dataSource}
            onChange={(e) => setDataSource(e.target.value)}
          >
            <option value="DB">DB</option>
            <option value="LIVE">ELK</option>
          </select>
        </div>

        <section className="my-account-section">
          <div className="my-account-section_header">
            <ul
              className="input-list"
              style={{ display: "flex", alignItems: "center" }}
            >
              <li style={{ display: "flex", alignItems: "center" }}>
                <label>Type &nbsp;</label>
                <select name="sports" id="sports" style={{ marginRight: 0 }}>
                  <option value="11">SABA Sports</option>
                  <option value="1">Vgaming</option>
                  <option value="2">Lottery</option>
                  <option value="3">RNG Keno</option>
                  <option value="4">Virtual Sports 3</option>
                  <option value="5">Saba Virtual Sports</option>
                  <option value="6">Virtual Sports 2</option>
                  <option value="7">Number Game</option>
                  <option value="8">SportsBook</option>
                </select>
              </li>

              <li style={{ display: "flex", alignItems: "center" }}>
                <label style={{ marginLeft: "8px", marginRight: "8px" }}>
                  Period
                </label>
                <input
                  id="betsstartDate"
                  className="cal-input"
                  type="date"
                  value={`${moment(startDate).format("YYYY-MM-DD")}`}
                  placeholder="YYYY-MM-DD"
                  onChange={(e: any) => {
                    const newDate = new Date(e?.target?.value);
                    setStartDate(newDate);
                  }}
                />
                <span style={{ margin: "0 5px" }}>to</span>
                <input
                  id="betsendDate"
                  className="cal-input"
                  type="date"
                  value={`${moment(endDate).format("YYYY-MM-DD")}`}
                  placeholder="YYYY-MM-DD"
                  onChange={(e: any) => setEndDate(new Date(e?.target?.value))}
                />
              </li>
            </ul>

            <ul className="input-list">
              <li>
                <a
                  id="today"
                  className="btn"
                  style={{
                    backgroundColor: "#FFB80C",
                    color: "#000",
                    border: "1px solid #ffb80c",
                    cursor: "pointer",
                  }}
                  onClick={() => filterButtonClick("today")}
                >
                  Just For Today
                </a>
              </li>
              <li>
                <a
                  id="yesterday"
                  className="btn"
                  style={{
                    backgroundColor: "#FFB80C",
                    color: "#000",
                    border: "1px solid #ffb80c",
                    cursor: "pointer",
                  }}
                  onClick={() => filterButtonClick("yesterday")}
                >
                  From Yesterday
                </a>
              </li>
              <li>
                <a
                  id="getPL"
                  className="btn-send"
                  style={{
                    backgroundColor: "#FFB80C",
                    color: "#000",
                    border: "1px solid #000",
                    cursor: "pointer",
                  }}
                  onClick={() => getFilterButtonClick()}
                >
                  Get P &amp; L
                </a>
              </li>
            </ul>
          </div>

          <div className="my-account-section-content">
            <div className="my-account-section-content-table">
              {isLoader && <Loader />}
              <table id="resultTable" className="table01 margin-table">
                <thead>
                  <tr>
                    <th className="light-grey-bg">S No</th>
                    <th className="light-grey-bg">Website</th>
                    <th className="light-grey-bg">UID</th>
                    <th className="light-grey-bg">Vgamin P/L</th>
                    <th className="light-grey-bg">Lottery P/L</th>
                    <th className="light-grey-bg">RNG Keno P/L</th>
                    <th className="light-grey-bg">Virtual Sports 3 <br />P/L</th>
                    <th className="light-grey-bg">Saba Virtual <br />Sports P/L</th>
                    <th className="light-grey-bg">Virtual Sports 2 <br />P/L</th>
                    <th className="light-grey-bg">Number Game <br />P/L</th>
                    <th className="light-grey-bg">SportsBook <br />P/L</th>
                    <th className="light-grey-bg">Comm.</th>
                    <th className="light-grey-bg">Total P/L</th>
                  </tr>
                </thead>
                {!isLoader && pageData?.data && pageData?.data?.length > 0 && (
                  <>
                    <tbody>
                      {pageData.data.map((item: any, index: number) => (
                        <tr key={item._id || index}>
                          <td>{index + 1}</td>
                          <td>{item.website || "-"}</td>
                          <td className="uid-name">
                            <a
                              href="javascript:void(0)"
                              onClick={() => userClick(item)}
                              className="text-decoration-none"
                            >
                              <span className="badge bg-warning text-dark me-1">
                                {item.agent_level}
                              </span>
                              <span style={{ textDecoration: "underline" }}>
                                {item.username ||
                                  item.user_name ||
                                  item.name ||
                                  item.UID ||
                                  "-"}
                              </span>
                            </a>
                          </td>
                          <td>{item.vgamingPL || 0}</td>
                          <td>{item.lotteryPL || 0}</td>
                          <td>{item.rngKenoPL || 0}</td>
                          <td>{item.virtualSports3PL || 0}</td>
                          <td>{item.sabaVirtualSportsPL || 0}</td>
                          <td>{item.virtualSports2PL || 0}</td>
                          <td>{item.numberGamePL || 0}</td>
                          <td>{item.sportsBookPL || 0}</td>
                          <td>{item.comm || 0}</td>
                          <td>{item.totalPL || 0}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <style>{`
                        .table01 tfoot th {
                          border-top: 1px solid #7e97a7 !important;
                          border-bottom: 1px solid #fff !important;
                          background: transparent;
                        }
                      `}</style>
                      <tr>
                        <th className="border-top"></th>
                        <th className="border-top"></th>
                        <th className="border-top">
                          <strong>Total</strong>
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.vgamingPL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.vgamingPL ?? 0}
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.lotteryPL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.lotteryPL ?? 0}
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.rngKenoPL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.rngKenoPL ?? 0}
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.virtualSports3PL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.virtualSports3PL ?? 0}
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.sabaVirtualSportsPL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.sabaVirtualSportsPL ?? 0}
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.virtualSports2PL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.virtualSports2PL ?? 0}
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.numberGamePL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.numberGamePL ?? 0}
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.sportsBookPL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.sportsBookPL ?? 0}
                        </th>
                        <th className="text-green border-top">
                          {pageData?.total?.comm ?? 0}
                        </th>
                        <th
                          className={`border-top ${(pageData?.total?.totalPL ?? 0) < 0 ? "text-danger" : "text-green"}`}
                        >
                          {pageData?.total?.totalPL ?? 0}
                        </th>
                      </tr>
                    </tfoot>
                  </>
                )}
              </table>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default SABADownline;
